
import DTO from './DTO';

export const PrinterType = {
    BLUETOOTH   : "bluetooth",
    NETWORK     : "network",
    FEIEYUN     : "feieyun",
    USB             : "usb",
    SUNMI           : "sunmi",
    DEVICE_CUSTOM   : "device_custom",
}
class Printer extends DTO {
    static dtoFromServer = (json) => {
        if (json.type === 'FeieYun') {
            json.server_name = "China"
            if (json.server === 'jp') {
                json.server_name = "Asia Pacific"
            }
        }
        return json
    }
}
export default Printer;